import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { NotificationProvider } from './context/NotificationContext';
import Notification from './components/Notification';
import Login from './components/Login';
import LoginDebug from './components/login_debug';
import DashboardLayout from './components/DashboardLayout';
import DataEntry from './components/DataEntry';
import TestCompset from './pages/TestCompset';
import IngresoExpress from './pages/IngresoExpress';
import DashboardIndividual from './pages/DashboardIndividual';
import RetrospectiveEntry from './components/RetrospectiveEntry';
import UserManagement from './components/UserManagement';
import HotelManagement from './components/HotelManagement';
import CompSetManagement from './components/CompSetManagement';
import ReporteClasico from './components/ReporteClasico';
import ReporteKPI from './components/ReporteKPI';
import Dashboard from './components/Dashboard/Dashboard';
import ImageManagement from './components/ImageManagement';
import RoleManagement from './components/RoleManagement';

import { hasPermission } from './utils/auth';

const getAuthStatus = () => {
    const token = localStorage.getItem('token');
    const userString = localStorage.getItem('user');
    if (!token || !userString) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        return { isAuthenticated: false, user: null };
    }
    try {
        const user = JSON.parse(userString);
        return { isAuthenticated: true, user: user };
    } catch (e) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        return { isAuthenticated: false, user: null };
    }
};

function AppContent() {
    const [authStatus, setAuthStatus] = useState(getAuthStatus());
    const navigate = useNavigate();
    const location = useLocation();

    const handleLoginSuccess = () => {
        setAuthStatus(getAuthStatus());
    };

    useEffect(() => {
        if (authStatus.isAuthenticated) {
            if (location.pathname === '/' || location.pathname === '/login' || location.pathname === '/debug-login') {
                if (hasPermission('dashboard_full')) {
                    navigate('/dashboard', { replace: true });
                } else if (hasPermission('dashboard_individual')) {
                    navigate('/dashboard-individual', { replace: true });
                } else if (hasPermission('data_entry')) {
                    navigate('/data-entry', { replace: true });
                } else {
                    navigate('/ingreso-express', { replace: true });
                }
            }
        }
    }, [authStatus, navigate, location.pathname]);

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('user_level');
        setAuthStatus({ isAuthenticated: false, user: null });
        navigate('/');
    };

    const getDefaultRedirectPath = () => {
        if (!authStatus.isAuthenticated) return '/login';
        if (hasPermission('dashboard_full'))       return '/dashboard';
        if (hasPermission('dashboard_individual')) return '/dashboard-individual';
        if (hasPermission('data_entry'))           return '/data-entry';
        if (hasPermission('ingreso_express'))      return '/ingreso-express';
        return '/login';
    };

    return (
        <>
            <Notification />
            <Routes>
                <Route path="/debug-login" element={!authStatus.isAuthenticated ? <LoginDebug onLoginSuccess={handleLoginSuccess} /> : <Navigate to={getDefaultRedirectPath()} replace />} />
                <Route path="/login" element={!authStatus.isAuthenticated ? <Login onLoginSuccess={handleLoginSuccess} /> : <Navigate to={getDefaultRedirectPath()} replace />} />
                <Route path="/" element={!authStatus.isAuthenticated ? <Login onLoginSuccess={handleLoginSuccess} /> : <Navigate to={getDefaultRedirectPath()} replace />} />

                {authStatus.isAuthenticated ? (
                    <Route element={<DashboardLayout onLogout={handleLogout} user={authStatus.user} />}>

                        {/* DASHBOARD */}
                        {hasPermission('dashboard_full') && (
                            <Route path="/dashboard" element={<Dashboard />} />
                        )}
                        {hasPermission('dashboard_individual') && (
                            <Route path="/dashboard-individual" element={<DashboardIndividual />} />
                        )}

                        {/* TEST */}
                        <Route path="/test-compset" element={<TestCompset />} />

                        {/* DATA ENTRY */}
                        {hasPermission('data_entry') && (
                            <Route path="/data-entry" element={<DataEntry />} />
                        )}

                        {/* INGRESO EXPRESS */}
                        {hasPermission('ingreso_express') && (
                            <Route path="/ingreso-express" element={<IngresoExpress />} />
                        )}

                        {/* RETROSPECTIVE */}
                        {hasPermission('retrospective') && (
                            <Route path="/ingreso-retrospectivo" element={<RetrospectiveEntry />} />
                        )}

                        {/* REPORTS */}
                        {hasPermission('report_clasico') && (
                            <Route path="/reports/clasico" element={<ReporteClasico />} />
                        )}
                        {hasPermission('report_kpi') && (
                            <Route path="/reports/kpi" element={<ReporteKPI />} />
                        )}

                        {/* CONFIG */}
                        {hasPermission('config_users') && (
                            <Route path="/config/users" element={<UserManagement />} />
                        )}
                        {hasPermission('config_hotels') && (
                            <Route path="/config/hotels" element={<HotelManagement />} />
                        )}
                        {hasPermission('config_compsets') && (
                            <Route path="/config/compsets" element={<CompSetManagement />} />
                        )}
                        {hasPermission('config_images') && (
                            <Route path="/config/images" element={<ImageManagement />} />
                        )}
                        {hasPermission('config_roles') && (
                            <Route path="/config/roles" element={<RoleManagement />} />
                        )}

                    </Route>
                ) : (
                    <Route path="*" element={<Navigate to="/login" replace />} />
                )}

                <Route path="*" element={<Navigate to={getDefaultRedirectPath()} replace />} />
            </Routes>
        </>
    );
}

function App() {
    return (
        <NotificationProvider>
            <AppContent />
        </NotificationProvider>
    );
}

export default App;